import { Member } from './member.model';

export class ExternalMember extends Member {
  address: string;
  addressComplement: string;
  city: string;
  companyAccountantEmail: string;
  companyAccountantFirstName: string;
  companyAccountantJob: string;
  companyAccountantLastName: string;
  companyAddress: string;
  companyAddressComplement: string;
  companyCity: string;
  companyCommercialName: string;
  companyImmatriculationNumber: string;
  companyManagerEmail: string;
  companyManagerFirstName: string;
  companyManagerJob: string;
  companyManagerLastName: string;
  companyName: string;
  companyVatNumber: string;
  companyZipCode: string;
  country: string;
  email?: string;
  firstName?: string;
  isB2b: boolean;
  lastName?: string;
  phoneNumber: string;
  plainPassword?: string;
  zipCode: string;

  constructor(values= {}) {
    super(values);
  }
}
